import { NAV_ITEMS, MORE_ITEMS, NavItem, filterNavItems } from './navConfig';

const byId = (id: string): NavItem => {
  const item = NAV_ITEMS.find((n) => n.id === id);
  if (!item) throw new Error(`mobileNav: NAV_ITEMS has no id "${id}"`);
  return item;
};

// Bottom bar: four primary route tabs + a synthetic "More" trigger (empty path).
export const MOBILE_TABS: NavItem[] = [
  byId('account'),
  byId('tasks'),
  byId('messages'),
  byId('notifications'),
  { id: 'more', icon: 'ellipsis', label: 'More', path: '' },
];

// More sheet: Timekeep (demoted from the primary set) + the desktop More items.
export const MOBILE_MORE: NavItem[] = [byId('timekeep'), ...MORE_ITEMS];

/**
 * Maps a route pathname to the id of the matching nav entry, or null when no
 * entry owns it (e.g. /projects/:id, /profile). Matches on the first path
 * segment so detail routes still resolve to their tab.
 */
export const pathnameToTabId = (pathname: string): string | null => {
  if (!pathname || pathname === '/') return 'account';
  const seg = `/${pathname.split('/')[1]}`;
  const match = [...NAV_ITEMS, ...MORE_ITEMS].find((i) => i.path === seg);
  return match ? match.id : null;
};

/** More items filtered for the current user — mirrors the desktop RailSidebar. */
export const mobileMoreItems = (
  isExternal: boolean,
  permissions?: Record<string, boolean>
): NavItem[] => filterNavItems(MOBILE_MORE, { isExternal, permissions });
